// src/components/About.jsx
import React from "react";

export default function About() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-4 leading-relaxed text-sm"
      aria-labelledby="about-pat-heading"
    >
      <h2
        id="about-pat-heading"
        className="text-lg font-bold text-gray-100 mb-2"
      >
        What is Probability Analysis Theory™ (PAT)?
      </h2>

      <p>
        <strong>Probability Analysis Theory™ (PAT)</strong> is a formal theory
        of probabilistic reasoning that examines how claims, explanations, and
        conclusions are justified under uncertainty. It provides a structured
        account of how beliefs relate to evidence, assumptions, and causal
        interpretations.
      </p>

      <p>
        PAT operationalises reasoning as an explicit analytical process. Each
        inquiry is decomposed into identifiable variables, probabilistic
        dependencies, candidate variables, and, where authorised, causal
        structures, allowing uncertainty to be represented, evaluated, and
        compared in a principled way.
      </p>

      <p>
        PAT performs structured causal-question preparation, role partitioning,
        DAG confirmation, and audit reporting. Formal causal-identification
        extensions can be developed collaboratively where required.
      </p>

      <p>
        The theory assigns accountable probabilistic credences by analysing the
        quality of evidence, the coherence of authorised causal pathways, and
        the internal consistency of assumptions. These credences function as
        measures of justification rather than claims of truth.
      </p>

      <p>
        PAT integrates probabilistic modelling with causal analysis to support
        transparent interpretation across empirical, conceptual, ethical, and
        policy-relevant domains. Its structure enables users to trace how
        conclusions arise from inputs, and how changes in assumptions alter
        interpretations or model outputs.
      </p>

      <p>
        As a theory of applied reasoning, PAT supports disciplined inquiry in
        contexts where uncertainty, complexity, and interpretive judgment are
        unavoidable. It establishes a coherent link between probability,
        causality, and epistemic responsibility.
      </p>

      <p>
        PAT Engine implements Probability Analysis Theory within an interactive
        analytical environment, enabling users to engage directly with the
        theory’s principles through structured reasoning workflows and
        interpretable outputs.
      </p>
    </section>
  );
}
